import { createIntl, createIntlCache } from 'react-intl';
import { v1 as uuid } from 'uuid';
import messages from '../../../../../assets/messages';
import renderLocale from '../../../../helpers/renderLocale';
import { TradeState } from '../../../../types/trade';

// The following enums cover accepted sortMethods from the API
enum SharedTradeSortMethods {
  Newest = 0,
  Oldest = 1,
  DealerAscending = 2,
  DealerDescending = 3,
  YearNewest = 4,
  YearOldest = 5,
  MileageFewest = 6,
  MileageMost = 7
}

export enum TradeSortMethodsUpcoming {
  LaunchTimeSoonest = 8,
  LaunchTimeLatest = 9
}

export enum TradeSortMethodsActive {
  ActiveNewest = 10,
  ActiveOldest = 11,
  ActiveTimerNewest = 12,
  ActiveTimerOldest = 13
}

export type TradeSortMethods =
  | SharedTradeSortMethods
  | TradeSortMethodsActive
  | TradeSortMethodsUpcoming;

export type TradeSortMethodUpdater = (sortMethod: TradeSortMethods) => void;

export type TradeSortOptionsUpcoming = {
  id: string;
  value: TradeSortMethodsUpcoming | SharedTradeSortMethods;
  label: string;
  isDefault: boolean;
};

export const TradeSortOptionsByTime = [
  SharedTradeSortMethods.Newest,
  SharedTradeSortMethods.Oldest,
  TradeSortMethodsUpcoming.LaunchTimeSoonest,
  TradeSortMethodsUpcoming.LaunchTimeLatest,
  TradeSortMethodsActive.ActiveNewest,
  TradeSortMethodsActive.ActiveOldest
];

const locale = renderLocale();
const intl = createIntl(
  { locale, messages: messages[locale] },
  createIntlCache()
);

export const tradeSortOptionsUpcoming: TradeSortOptionsUpcoming[] = [
  {
    id: uuid(),
    value: TradeSortMethodsUpcoming.LaunchTimeSoonest,
    label: intl.formatMessage({ id: 'list.sorting.activeSoonest' }),
    isDefault: true
  },
  {
    id: uuid(),
    value: TradeSortMethodsUpcoming.LaunchTimeLatest,
    label: intl.formatMessage({ id: 'list.sorting.recentlyListed' }),
    isDefault: false
  },
  {
    id: uuid(),
    value: SharedTradeSortMethods.MileageFewest,
    label: intl.formatMessage({ id: 'list.sorting.mileageLowHigh' }),
    isDefault: false
  },
  {
    id: uuid(),
    value: SharedTradeSortMethods.MileageMost,
    label: intl.formatMessage({ id: 'list.sorting.mileageHighLow' }),
    isDefault: false
  },
  {
    id: uuid(),
    value: SharedTradeSortMethods.YearNewest,
    label: intl.formatMessage({ id: 'list.sorting.yearNewOld' }),
    isDefault: false
  },
  {
    id: uuid(),
    value: SharedTradeSortMethods.YearOldest,
    label: intl.formatMessage({ id: 'list.sorting.yearOldNew' }),
    isDefault: false
  }
];

export type TradeSortOptionsActive = {
  id: string;
  value: TradeSortMethodsActive | SharedTradeSortMethods;
  label: string;
  isDefault: boolean;
};

export const tradeSortOptionsActive: TradeSortOptionsActive[] = [
  {
    id: uuid(),
    value: TradeSortMethodsActive.ActiveOldest,
    label: intl.formatMessage({ id: 'list.sorting.endingSoonest' }),
    isDefault: true
  },
  {
    id: uuid(),
    value: TradeSortMethodsActive.ActiveNewest,
    label: intl.formatMessage({ id: 'list.sorting.recentlyListed' }),
    isDefault: false
  },
  {
    id: uuid(),
    value: SharedTradeSortMethods.MileageFewest,
    label: intl.formatMessage({ id: 'list.sorting.mileageLowHigh' }),
    isDefault: false
  },
  {
    id: uuid(),
    value: SharedTradeSortMethods.MileageMost,
    label: intl.formatMessage({ id: 'list.sorting.mileageHighLow' }),
    isDefault: false
  },
  {
    id: uuid(),
    value: SharedTradeSortMethods.YearOldest,
    label: intl.formatMessage({ id: 'list.sorting.yearOldNew' }),
    isDefault: false
  },
  {
    id: uuid(),
    value: SharedTradeSortMethods.YearNewest,
    label: intl.formatMessage({ id: 'list.sorting.yearNewOld' }),
    isDefault: false
  }
];

export const tradeSortOptionsByTradeState = {
  [TradeState.active]: tradeSortOptionsActive,
  [TradeState.upcoming]: tradeSortOptionsUpcoming
};
